import React, { Component, Fragment } from 'react'
import AutoInput from '../containers/AutoInput'
import withValues from '../hocs/withValues'
import { getValue, getBelongsToValue } from '../utils/models'
import _ from 'lodash'
import { message } from 'antd'

class ReferenceForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            type: undefined,
            items: [],
            fetching: false,
            validateStatus: undefined
        }
    }


    componentWillReceiveProps(nextProps) {
        if (!this.state.type) {
            this.setState({ type: getValue(nextProps.values, 'type') })
        }
    }

    async componentWillMount() {
        this.setState({ fetching: false })
        try {
            // const url = `${custom.appUrl}/input/transporte/cruces/${this.props.customerId}`;
            // const response = await request('crossing', { url })

            this.setState({
                items: []
            })

        } catch (error) {

            if (error.data) {
                this.setState({
                    items: [],
                    loading: false
                })
            } else {
                console.error(error.response)
            }
        }

        this.setState({ fetching: false })
    }

    handleChange(value) {
        this.setState({ type: value }, () => {
            this.props.form.setFieldsValue({
                reference: undefined
            })
        })
    }

    validate = _.debounce(async (rule, value, callback) => {
        this.setState({ validateStatus: 'validating' })

        try {
            // const response = await request('crossing', {
            //     url: `${custom.appUrl}/input/transporte/pedimento/${value}/${this.props.customerId}/1`
            // })
            const response = { data: { exist: true }};

            if (response.data.exist) {
                this.setState({ validateStatus: 'success' })
                message.success('Pedimento correcto')
                callback()
                return
            }
        } catch (error) {
            console.error('error', error)

            if (error.data && error.data.exist) {
                this.setState({ validateStatus: 'success' })
                message.success('Pedimento correcto')
                callback()
                return
            }
        }

        this.setState({ validateStatus: 'error' })
        message.error('Pedimento incorrecto')
        callback('error')
    }, 500)

    render() {
        let referenceProps = {}

        if (this.state.type === 5) {
            referenceProps.hasFeedback = true
            referenceProps.validateStatus = this.state.validateStatus
            referenceProps.validator = (rule, value, callback) => {
                this.validate(rule, value, callback)
            }
        }
        console.log(this.state.type);
        return (
            <Fragment>
                {
                    this.props.belongsTo.association === 'dispatch' &&
                    <AutoInput
                        form={this.props.form}
                        model={'reference'}
                        attribute={'dispatch'}
                        value={getBelongsToValue('reference', this.props.belongsTo)}
                        hidden
                    />
                }
                <AutoInput
                    form={this.props.form}
                    model={'reference'}
                    attribute={'type'}
                    value={getValue(this.props.values, 'type')}
                    onChange={(value) => { this.handleChange(value) }}
                    delayTime={100}
                />
                {
                    this.state.type !== 8 && (
                        <AutoInput
                            form={this.props.form}
                            model={'reference'}
                            attribute={'reference'}
                            loading={false}
                            value={getValue(this.props.values, 'reference')}
                            placeholder={this.state.type === 5 ? '0000-0000000' : null}
                            {...referenceProps}
                        />
                    )
                }
                {
                    this.state.type === 8 &&
                    <AutoInput
                        form={this.props.form}
                        model={'reference'}
                        attribute={'reference'}
                        type={'model'}
                        loading={false}
                        items={this.state.items}
                        fetching={false}
                        value={getValue(this.props.values, 'reference')}
                    />
                }
                {
                    [5, 6].includes(this.state.type) &&  (
                        <AutoInput
                            form={this.props.form}
                            model={'reference'}
                            attribute={'importerRfc'}
                            value={getValue(this.props.values, 'importerRfc')}
                            onChange={(value) => this.setState({ importerRfc: value })}
                        />
                    )
                }
            </Fragment>
        )
    }

}

export default withValues(ReferenceForm)



// WEBPACK FOOTER //
// ./src/forms/Reference.js